export type PrizmIdentityMatcherFunc<T> = (a: T, b: T) => boolean;
